<template>
    <div class="uk-container uk-container-expand uk-padding-small card-scrollable main">
        <LoaderPage v-if="isLoading" />
        <template v-else-if="$can('READ', 'worker-deposit')">
            <!-- Page header -->
            <div class="uk-flex uk-flex-middle uk-flex-between">
                <p class="uk-padding-remove uk-margin-remove uk-text-bold">
                    Mitra Deposit
                </p>
                <div v-if="activeTab == 'mitra_deposit_list'" class="uk-flex uk-flex-column uk-flex-left uk-flex-top gap-10px">
                    <div class="uk-width-expand">
                        <button
                            type="button"
                            class="uk-button uk-width-expand uk-button-primary uk-border-rounded"
                            @click="downloadDepositBatchReport"
                        >Report</button>
                    </div>
                    <div v-if="$can('EDIT', 'worker-deposit')" class="uk-width-expand">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-width-expand uk-border-rounded myrobin-color-blue myrobin-border-blue"
                            @click="distributeBatch"
                        >Blast to Mitra</button>
                    </div>
                </div>
                <div v-else>
                    <div v-if="$can('EDIT', 'worker-deposit')" class="uk-width-expand">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-width-expand uk-border-rounded myrobin-color-blue myrobin-border-blue"
                            @click="distributMitraDeposit"
                        >Send to Mitra</button>
                    </div>
                </div>
            </div>
            <!-- End page header -->

            <template>
                <!-- Tab button -->
                <div class="uk-grid-small" uk-grid>
                    <div class="uk-width-1-4">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-border-rounded uk-width-1-1"
                            :class="[activeTab === 'mitra_deposit_list' ? 'myrobin-background-primary myrobin-color-white' : 'uk-button-disabled myrobin-border-grey myrobin-color-grey']"
                            :disabled="activeTab === 'mitra_deposit_list'"
                            @click="setActiveTabMenu('mitra_deposit_list')"
                        >Deposit Template</button>
                    </div>
                    <div class="uk-width-1-4">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-border-rounded uk-width-1-1"
                            :class="[activeTab === 'mitra_deposit_detail' ? 'myrobin-background-primary myrobin-color-white' : 'uk-button-disabled myrobin-border-grey myrobin-color-grey']"
                            :disabled="activeTab === 'mitra_deposit_detail'"
                        >Detail Deposit Mitra</button>
                    </div>
                </div>
                <!-- End tab button -->

                <!-- Tab content -->
                <div class="uk-width-1-1 uk-margin-top">
                    <DepositBatchDetail
                        v-if="activeTab === 'mitra_deposit_list'"
                        :mitra-deposit-list="mitraDepositList"
                        :table-loading="tableLoading"
                        @search-mitra-deposit="searchMitraDeposit"
                        @get-deposit-data="getDepositBatchData"
                        @see-mitra-deposit-detail="seeMitraDepositDetail"
                        @change-limit="changeLimit"
                        @change-page="changePage"
                    />
                    <MitraDepositDetail
                        v-if="activeTab === 'mitra_deposit_detail'"
                    />
                </div>
                <!-- End tab content -->
            </template>

            <!-- Loading modal box -->
            <div id="processing-modal" class="processing-modal" uk-modal esc-close="false" bg-close="false">
                <div class="uk-modal-dialog">
                    <div class="uk-modal-body">
                        <div class="uk-flex uk-flex-column uk-flex-middle uk-flex-center">
                            <div uk-spinner="ratio: 2"></div>
                            <div class="uk-margin-top">Please wait...</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End of loading modal box -->
        </template>

        <!-- Handler when user can't access -->
        <div v-else>
            <div class="uk-flex uk-flex-center uk-flex-middle uk-height-viewport">
                <div class="uk-flex uk-flex-center uk-flex-middle uk-width-1-1">
                    <span class="uk-text-large uk-text-bold">
                        <p>You are not authorized for read data this page</p>
                    </span>
                </div>
            </div>
        </div>
        <!-- End handler when user can't access -->

    </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
    notificationSuccess,
    notificationDangerCustom,
    notificationDanger
} from '@/utils/notification';
import { excelDownloader } from '@/utils/helper';

export default {
    name: 'DepositBatch',
    components: {
        LoaderPage: () => import('@/components/globals/LoaderPage'),
        DepositBatchDetail: () => import('@/components/globals/MitraDeposit/DepositBatchDetail'),
        MitraDepositDetail: () => import('@/components/globals/MitraDeposit/MitraDepositDetail'),
    },
    data() {
        return {
            isLoading: false,
            activeTab: 'mitra_deposit_list',
            mitraDepositList: null,
            batchDetail: null,
            meta: {
                id: this.$route.params.id,
                limit: 10,
                page: 1,
                query_input: ''
            },
            tableLoading: false,
            downloadReportLoading: false,
        };
    },
    watch: {
        async meta() {
            try {
                await this.getDepositBatchData();
            } catch (error) {
                notificationDanger(error);
            }
        },
    },
    async beforeMount() {
        if (window.UIkit.modal('#processing-modal')) window.UIkit.modal('#processing-modal').$destroy(true);

        try {
            this.isLoading = true;
            await this.getDepositBatchData();
            this.setFirstActiveTabMenu();
        } catch (error) {
            notificationDanger(error);
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        ...mapActions({
            getDepositBatchDetail: 'mitra_deposit/getDepositBatchDetail',
            distributeDepositBatch: 'mitra_deposit/distributeDepositBatch',
            distributeSingleDeposit: 'mitra_deposit/distributeSingleDeposit',
            depositBatchReport: 'mitra_deposit/depositBatchReport',
        }),
        async setFirstActiveTabMenu() {
            try {
                if (this.$route.query.tab === undefined) await this.setQueryURL('mitra_deposit_list');
                this.activeTab = this.$route.query.tab;
            } catch (error) {
                notificationDanger(error);
            }
        },
        async setActiveTabMenu(tab) {
            try {
                if (this.$route.query.tab !== undefined) await this.setQueryURL(tab);
                this.activeTab = tab;
            } catch (error) {
                notificationDanger(error);
            }
        },
        async setQueryURL(tab) {
            try {
                await this.$router.replace({
                    path: `/admin/workers/deposit/${this.$route.params.id}`,
                    query: { tab }
                });
            } catch (error) {
                notificationDanger(error);
            }
        },
        async seeMitraDepositDetail(id) {
            try {
                const tab = 'mitra_deposit_detail';
                await this.$router.replace({
                    path: `/admin/workers/deposit/${this.$route.params.id}`,
                    query: { tab, deposit_id: id }
                });
                this.activeTab = tab;
            } catch (error) {
                notificationDanger(error);
            }
        },
        async getDepositBatchData() {
            try {
                this.tableLoading = true;
                const result = await this.getDepositBatchDetail(this.meta);
                this.batchDetail = result.batch;
                this.mitraDepositList = result.deposit_list;
            } catch (error) {
                notificationDanger(error);
            } finally {
                this.tableLoading = false;
            }
        },
        async searchMitraDeposit(payloads) {
            try {
                this.meta.id = this.$route.params.id;
                this.meta.limit = 10;
                this.meta.page = 1;
                this.meta.query_input = payloads;
                await this.getDepositBatchData();
            } catch (error) {
                notificationDanger(error);
            }
        },
        async distributeBatch() {
            try {
                await window.UIkit.modal('#processing-modal').show();
                const response = await this.distributeDepositBatch(this.$route.params.id);
                if (response && response.status === 'OK') {
                    notificationSuccess('Deposit batch blasted successfully.');
                } else {
                    notificationDangerCustom('Failed to blast deposit batch.');
                }
            } catch (error) {
                notificationDanger(error);
            } finally {
                await window.UIkit.modal('#processing-modal').hide();
            }
        },
        async distributMitraDeposit() {
            try {
                const response = await this.distributeSingleDeposit(this.$route.query.deposit_id);

                if (response && response.status === 'OK') {
                    notificationSuccess('Mitra deposit sent successfully.');
                } else {
                    notificationDangerCustom('Failed to send mitra deposit.');
                }
            } catch (error) {
                notificationDanger(error);
            }
        },
        async downloadDepositBatchReport() {
            try {
                this.downloadDepositBatchLoading = true;

                const result = await this.depositBatchReport(this.$route.params.id);

                const companyName = result.batch.company_id?.name || 'Tidak diketahui';
                const batchName = result.batch.name;
                const dataExcel = result.deposit_list;

                const file_name = `Report Mitra Deposit_${companyName}_${batchName}.xlsx`;
                excelDownloader(dataExcel, file_name);
                notificationSuccess(`Mitra deposit excel downloaded successfully.`);
            } catch (error) {
                notificationDanger(error);
                notificationDangerCustom(`Failed to download mitra deposit.`);
            } finally {
                this.downloadDepositBatchLoading = false;
            }
        },
        changeLimit(e) {
            this.meta = {
                ...this.meta,
                limit: e.target.value
            };
        },
        changePage(value) {
            this.meta = {
                ...this.meta,
                page: value
            };
        },
    }
};
</script>

<style scoped>
.myrobin-background-primary {
    background-color: #0ABAB5;
}
.myrobin-color-white {
    color: #FFFFFF;
}
.myrobin-color-grey {
    color: #9A9A9A;
}
.gap-10px {
    gap: 10px;
}
.gap-20px {
    gap: 20px;
}
</style>
